import React, { FC, useEffect } from 'react';
import anime from 'animejs';

const Spinner: FC = () => {
  const spinnerAnimation = () => {
    const tl = anime.timeline({
      easing: 'easeOutExpo',
      // duration: 750
      loop: true,
    });

    tl.add({
      targets: '.prefix__line',
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: 1200,
      direction: 'normal',
    })
      .add({
        targets: '.prefix__line',
        strokeDashoffset: [-0, -1460],
        easing: 'easeInOutSine',
        duration: 1000,
        direction: 'normal',
      })
      .add(
        {
          targets: '.prefix__lines',
          duration: 1300,
          rotate: '1turn',
          easing: 'easeInOutSine',
          opacity: [
            { value: 0, duration: 1 },
            { value: 1, duration: 1 },
          ],
          strokeDashoffset: [{ value: -1460, duration: 700, delay: 700 }],
          delay: (el, i) => {
            return i * 120;
          },
        },
        1010
      );
  };
  useEffect(() => {
    spinnerAnimation();
  }, []);
  return (
    <div className="loader">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        style={{ width: '8%' }}
      >
        <linearGradient
          id="prefix__a"
          gradientUnits="userSpaceOnUse"
          x1={74.781}
          y1={74.798}
          x2={425.219}
          y2={425.202}
        >
          <stop offset={0} stopColor="#fde44c" />
          <stop offset={0.642} stopColor="#e662d8" />
          <stop offset={0.686} stopColor="#da61d9" />
          <stop offset={0.765} stopColor="#ba5ddb" />
          <stop offset={0.871} stopColor="#8657df" />
          <stop offset={0.998} stopColor="#3f4fe4" />
          <stop offset={1} stopColor="#3e4fe4" />
        </linearGradient>
        <path
          className="prefix__lines"
          style={{ opacity: '0', transformOrigin: 'center' }}
          d="M250 17.215c128.564 0 232.785 104.221 232.785 232.785S378.564 482.785 250 482.785 17.215 378.564 17.215 250 121.436 17.215 250 17.215z"
          strokeDasharray={2844.81}
          fill="none"
          stroke="url(#prefix__a)"
          strokeWidth={30}
          strokeMiterlimit={10}
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeDashoffset={-1350}
        />
        <linearGradient
          id="prefix__b"
          gradientUnits="userSpaceOnUse"
          x1={74.781}
          y1={74.798}
          x2={425.219}
          y2={425.202}
        >
          <stop offset={0} stopColor="#fde44c" />
          <stop offset={0.642} stopColor="#e662d8" />
          <stop offset={0.686} stopColor="#da61d9" />
          <stop offset={0.765} stopColor="#ba5ddb" />
          <stop offset={0.871} stopColor="#8657df" />
          <stop offset={0.998} stopColor="#3f4fe4" />
          <stop offset={1} stopColor="#3e4fe4" />
        </linearGradient>
        <path
          className="prefix__lines"
          style={{ opacity: '0', transformOrigin: 'center' }}
          d="M250 17.215c128.564 0 232.785 104.221 232.785 232.785S378.564 482.785 250 482.785 17.215 378.564 17.215 250 121.436 17.215 250 17.215z"
          strokeDasharray={2844.81}
          fill="none"
          stroke="url(#prefix__b)"
          strokeWidth={30}
          strokeMiterlimit={10}
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeDashoffset={-1350}
        />
        <linearGradient
          id="prefix__c"
          gradientUnits="userSpaceOnUse"
          x1={74.781}
          y1={74.798}
          x2={425.219}
          y2={425.202}
        >
          <stop offset={0} stopColor="#fde44c" />
          <stop offset={0.642} stopColor="#e662d8" />
          <stop offset={0.686} stopColor="#da61d9" />
          <stop offset={0.765} stopColor="#ba5ddb" />
          <stop offset={0.871} stopColor="#8657df" />
          <stop offset={0.998} stopColor="#3f4fe4" />
          <stop offset={1} stopColor="#3e4fe4" />
        </linearGradient>
        <path
          className="prefix__line"
          style={{ position: 'relative', zIndex: 1 }}
          d="M250 17.215c128.564 0 232.785 104.221 232.785 232.785S378.564 482.785 250 482.785 17.215 378.564 17.215 250 121.436 17.215 250 17.215z"
          fill="none"
          stroke="url(#prefix__c)"
          strokeWidth={30}
          strokeMiterlimit={10}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
export default Spinner;
